import React, { useCallback, useEffect, useState } from 'react';
import './header.css';
import { GoSun, GoMoon } from 'react-icons/go';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const getStoredTheme = localStorage.getItem("theme") || '';
  const [toggle, setToogle] = useState(false);
  const [theme, setTheme] = useState(getStoredTheme);
  const [scrolled, setScrolled] = useState(false);
  const [modal, setModal] = useState(false);
  const [active, setActive] = useState("anasayfa");

  const navigate = useNavigate();

  const handleActive = (item) => {
    setActive(item);
  };

  const changeTheme = useCallback((newTheme) => {
    const previousTheme = localStorage.getItem("theme");
    if (previousTheme) {
      document.body.classList.remove(previousTheme);
    }
    if (newTheme) {
      document.body.classList.add(newTheme);
      localStorage.setItem("theme", newTheme);
    }
  }, []);


  useEffect(() => {
    const path = location.pathname;
    switch (path) {
      case "/":
        setActive("anasayfa");
        break;
      case "/hakkimizda":
        setActive("hakkimizda");
        break;
      case "/yonetim":
        setActive("yonetim");
        break;
      case "/calisanlar":
        setActive("calisanlar");
        break;
      case "/hizmetlerimiz":
        setActive("hizmetlerimiz");
        break;
      case "/iletisim":
        setActive("iletisim");
        break;
      case "/duyurular":
        setActive("duyurular");
        break;
      default:
        setActive("");
        break;
    }
  }, [location]);

  useEffect(() => {
    changeTheme(theme);
  }, [theme, changeTheme]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (modal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [modal]);

  return (
    <>
      <div className={`toggle-background ${scrolled && !toggle ? 'scrolled' : ''}`}>
        <div
          onClick={() => {
            setToogle(!toggle);
            setModal(!modal);
          }}
          className={`toggle ${toggle ? 'active' : ''}`}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      {modal && (
        <div className="toggle-modal">
          <div className="modal-elements">
            <ul>
              {[
                { path: "/", label: "Anasayfa" },
                { path: "/hakkimizda", label: "Hakkımızda" },
                { path: "/yonetim", label: "Yönetim" },
                { path: "/destek", label: "Destek" },
                { path: "/calisanlar", label: "Çalışanlar" },
                { path: "/hizmetlerimiz", label: "Hizmetlerimiz" },
                { path: "/iletisim", label: "İletişim" },
                { path: "/duyurular", label: "Duyurular" }
              ].map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => {
                    setModal(false);
                    setToogle(false);
                  }}
                >
                  <li>{item.label}</li>
                </Link>
              ))}
              <div
                onClick={() => {
                  setTheme(theme === "dark" ? "light" : "dark");
                  setModal(false);
                  setToogle(false);
                }}
                className="theme-icon-mobil"
              >
                {theme === "dark" ? <GoSun /> : <GoMoon />}
              </div>
            </ul>
          </div>
        </div>
      )}
      <header className={`header ${scrolled ? 'scrolled' : ''}`}>
        <div className="header-logo">
          <h2>ATA LOJMAN</h2>
        </div>
        <div className="header-elements">
          <ul>
            {[
              { path: "/", label: "Anasayfa", key: "anasayfa" },
              { path: "/hakkimizda", label: "Hakkımızda", key: "hakkimizda" },
              { path: "/yonetim", label: "Yönetim", key: "yonetim" },
              { path: "/calisanlar", label: "Çalışanlar", key: "calisanlar" },
              { path: "/hizmetlerimiz", label: "Hizmetlerimiz", key: "hizmetlerimiz" },
              { path: "/iletisim", label: "İletişim", key: "iletisim" },
              { path: "/duyurular", label: "Duyurular", key: "duyurular" }
            ].map((item) => (
              <Link key={item.key} to={item.path}>
                <li
                  onClick={() => handleActive(item.key)}
                  className={`${active === item.key ? 'active' : ''}`}
                >
                  {item.label}
                </li>
              </Link>
            ))}
          </ul>
        </div>
        <div className="header-right-side">
          <div
            onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
            className="theme-icon"
          >
            {theme === 'dark' ? <GoSun /> : <GoMoon />}
          </div>
          <div onClick={() => navigate("/destek")} className="header-support">
            <div className="header-support-text">
              <p>Destek</p>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
